// Bonusové vstupy na bootcamp (1. 11. 2026, hlášení 191).
//
// Láďa dává klientkám bootcampu vstup navíc, třeba za přivedenou kamarádku.
// Bonus se přičte k aktivní permanentce klientky, platnost zůstává stejná.
// Server si zapíše kdo, kdy a proč (tabulka bootcamp_bonusy), tady je jen
// tlačítko, okno a historie. Používá to detail klientky bootcampu
// (Bootcamps → Klientky) i sekce Bootcamp v detailu klientky koučinku.
//
// Role hlídá server (akce bonus-pridat, bonus-smazat). smiBonus z odpovědi
// jen schová tlačítko tomu, kdo by stejně dostal odmítnutí.

import React, { useEffect, useMemo, useState } from "react";
import { Gift, Minus, Plus, Search, Trash2, UserRound, X } from "lucide-react";
import { Modal, HlavickaOkna, Field, Stitek } from "./ui.jsx";
import { Oznameni, Volby } from "./sales/salesUi.jsx";
import { confirmDialog } from "./confirmHost.jsx";
import { toast } from "./Toast.jsx";
import { apiFetch } from "../lib/api.js";
import { formatDate as fmtDate } from "../lib/format.js";

export const BONUS_MAX = 10;
const DUVOD_MAX = 200;
const KAMARADKA_MAX = 120;
const DUVOD_KAMARADKA = "Přivedla kamarádku";
const DUVODY = [
  { key: "kamaradka", label: DUVOD_KAMARADKA },
  { key: "jiny", label: "Jiný důvod", popis: "Napíšete vlastními slovy" },
];

export function sklonujVstup(n) {
  if (n === 1) return "vstup";
  if (n >= 2 && n <= 4) return "vstupy";
  return "vstupů";
}

function kdyText(iso) {
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return "";
  return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

async function posli(telo) {
  const r = await apiFetch("/api/bootcampy", { method: "POST", body: JSON.stringify(telo) });
  let j = {};
  try { j = await r.json(); } catch (_) { j = {}; }
  if (!r.ok || !j.ok) throw new Error(j.error || "Uložení se nepovedlo, zkuste to prosím znovu.");
  return j;
}

/** Pilulka „+1 bonus“ u permanentky. Nic, když bonus není. */
export function PilulkaBonus({ pocet, className = "" }) {
  const n = Number(pocet || 0);
  if (!n) return null;
  return <Stitek ton="zlata" velikost="mala" ikona={Gift} className={className}>+{n} bonus</Stitek>;
}

const bezDiakritiky = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim();

/**
 * Výběr kamarádky (3. 11. 2026): klientky bootcampu ze seznamu, nebo ručně
 * napsané jméno (kamarádka třeba ještě není přihlášená). hodnota = { jmeno, klic }.
 */
function VyberKamaradky({ hodnota, onChange, vynechat }) {
  const [hledat, setHledat] = useState("");
  const [seznam, setSeznam] = useState(null);
  useEffect(() => {
    let zij = true;
    apiFetch("/api/bootcampy?klienti=1")
      .then((r) => r.json())
      .then((j) => { if (zij) setSeznam(Array.isArray(j && j.klienti) ? j.klienti : []); })
      .catch(() => { if (zij) setSeznam([]); });
    return () => { zij = false; };
  }, []);
  const q = bezDiakritiky(hledat);
  const nalezene = useMemo(() => {
    if (!q || !seznam) return [];
    const ja = bezDiakritiky(vynechat);
    return seznam.filter((k) => k.jmeno && bezDiakritiky(k.jmeno) !== ja && bezDiakritiky(k.jmeno).includes(q)).slice(0, 6);
  }, [q, seznam, vynechat]);
  const presne = nalezene.some((k) => bezDiakritiky(k.jmeno) === q);

  if (hodnota) {
    return (
      <div className="flex min-h-[44px] items-center gap-2 rounded-xl border border-brand-200 bg-brand-50 px-3 py-2">
        <Stitek ton="znacka" ikona={UserRound}><span className="select-none">{hodnota.jmeno}</span></Stitek>
        {!hodnota.klic && <span className="text-[12.5px] text-slate-500">zatím není mezi klientkami</span>}
        <span className="flex-1" />
        <button type="button" className="btn-ikona" onClick={() => { onChange(null); setHledat(""); }} aria-label="Vybrat jinou kamarádku" title="Vybrat jinou">
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }
  return (
    <div>
      <div className="relative">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <input className="field w-full pl-10" value={hledat} maxLength={KAMARADKA_MAX} autoFocus
          onChange={(e) => setHledat(e.target.value)}
          placeholder={seznam ? "Hledat klientku bootcampu, nebo napsat jméno" : "Načítám klientky…"} />
      </div>
      {q && (
        <div className="mt-1.5 overflow-hidden rounded-xl border border-slate-200 bg-white">
          {nalezene.map((k) => (
            <button key={k.klic} type="button" onClick={() => onChange({ jmeno: k.jmeno, klic: k.klic })}
              className="flex w-full items-center gap-2 border-b border-slate-100 px-3 py-2.5 text-left text-sm font-medium text-slate-800 last:border-b-0 hover:bg-brand-50">
              <UserRound className="h-4 w-4 shrink-0 text-slate-400" /> <span className="truncate">{k.jmeno}</span>
            </button>
          ))}
          {!presne && (
            <button type="button" onClick={() => onChange({ jmeno: hledat.replace(/\s+/g, " ").trim(), klic: null })}
              className="flex w-full items-center gap-2 bg-amber-50 px-3 py-2.5 text-left text-sm font-medium text-amber-900 hover:bg-amber-100">
              <Plus className="h-4 w-4 shrink-0" /> <span className="min-w-0 break-words">Použít „{hledat.trim()}“, zatím není mezi klientkami</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
}

/** Okno „Přidat bonusový vstup“. cil = kam bonus půjde (z API, bonusCil). */
export function PridatBonusDialog({ open, onClose, cil, jmeno, onHotovo }) {
  const [pocet, setPocet] = useState(1);
  const [duvod, setDuvod] = useState("kamaradka");
  const [text, setText] = useState("");
  const [kamaradka, setKamaradka] = useState(null);
  const [busy, setBusy] = useState(false);
  const [chyba, setChyba] = useState("");

  useEffect(() => {
    if (open) { setPocet(1); setDuvod("kamaradka"); setText(""); setKamaradka(null); setBusy(false); setChyba(""); }
  }, [open]);

  if (!cil) return null;
  const duvodText = duvod === "kamaradka" ? DUVOD_KAMARADKA : text.trim();
  const kamaradkaOk = duvod !== "kamaradka" || !!(kamaradka && kamaradka.jmeno);
  const lzeUlozit = !busy && pocet >= 1 && pocet <= BONUS_MAX && duvodText.length > 0 && duvodText.length <= DUVOD_MAX && kamaradkaOk;

  const uloz = async () => {
    if (!lzeUlozit) return;
    setBusy(true); setChyba("");
    try {
      const sKamaradkou = duvod === "kamaradka" && kamaradka
        ? { kamaradka: kamaradka.jmeno, ...(kamaradka.klic ? { kamaradka_klic: kamaradka.klic } : {}) }
        : {};
      const j = await posli({ akce: "bonus-pridat", ucastnice_id: cil.ucastnice_id, pocet, duvod: duvodText, ...sKamaradkou });
      toast(`Přidáno +${pocet} ${sklonujVstup(pocet)}${jmeno ? `, ${jmeno}` : ""}.`, "success");
      onClose();
      if (onHotovo) onHotovo(j);
    } catch (e) {
      setChyba(e.message);
    } finally {
      setBusy(false);
    }
  };

  const zbyvaPo = cil.zbyva == null ? null : Number(cil.zbyva) + pocet;

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      plnaHlavicka
      header={<HlavickaOkna ikona={Gift} nazev="Přidat bonusový vstup" popis={jmeno || undefined} onClose={onClose} />}
      footer={
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button type="button" className="btn-secondary w-full sm:w-auto" onClick={onClose}>Zrušit</button>
          <button type="button" className="btn-primary w-full sm:w-auto" onClick={uloz} disabled={!lzeUlozit} aria-busy={busy}>
            <Plus className="h-4 w-4" /> Přidat {pocet} {sklonujVstup(pocet)}
          </button>
        </div>
      }
    >
      <div className="space-y-4">
        {chyba && <Oznameni ton="problem">{chyba}</Oznameni>}

        <div className="rounded-xl border border-brand-200 bg-brand-50 px-3 py-2.5">
          <div className="text-xs font-semibold uppercase tracking-wide text-brand-deep">Přičte se k aktivní permanentce</div>
          <div className="mt-1.5 flex flex-wrap gap-1.5">
            {cil.tarif && <Stitek ton="znacka" velikost="mala">{cil.tarif}</Stitek>}
            <Stitek ton="neutralni" velikost="mala">{cil.platnost_do ? `platí do ${fmtDate(cil.platnost_do)}` : "bez data konce"}</Stitek>
            {zbyvaPo != null && <Stitek ton="ok" velikost="mala">zbývá {cil.zbyva}, po přidání {zbyvaPo}</Stitek>}
            <PilulkaBonus pocet={cil.bonus} />
          </div>
          <div className="mt-1.5 text-[13px] text-slate-600">Platnost permanentky zůstává stejná.</div>
        </div>

        <div>
          <span className="label">Počet vstupů</span>
          <div className="flex items-center gap-3">
            <button type="button" className="btn-ikona !h-12 !w-12" onClick={() => setPocet((n) => Math.max(1, n - 1))}
              disabled={pocet <= 1} aria-label="Ubrat vstup" title="Ubrat vstup">
              <Minus className="h-5 w-5" />
            </button>
            <span className="min-w-[3rem] text-center text-2xl font-extrabold tabular-nums text-slate-900" aria-live="polite">{pocet}</span>
            <button type="button" className="btn-ikona !h-12 !w-12" onClick={() => setPocet((n) => Math.min(BONUS_MAX, n + 1))}
              disabled={pocet >= BONUS_MAX} aria-label="Přidat vstup" title="Přidat vstup">
              <Plus className="h-5 w-5" />
            </button>
            <span className="text-[13px] text-slate-500">nejvýš {BONUS_MAX}</span>
          </div>
        </div>

        <div>
          <span className="label">Důvod</span>
          <Volby moznosti={DUVODY} value={duvod} onChange={setDuvod} name="Důvod bonusu" />
        </div>
        {duvod === "kamaradka" && (
          <div>
            <span className="label">Kterou kamarádku přivedla</span>
            <VyberKamaradky hodnota={kamaradka} onChange={setKamaradka} vynechat={jmeno} />
          </div>
        )}
        {duvod === "jiny" && (
          <Field label="Jaký důvod" hint={`${text.trim().length} z ${DUVOD_MAX} znaků`}>
            <input className="field" value={text} maxLength={DUVOD_MAX} autoFocus
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); uloz(); } }}
              placeholder="Například omluva za zrušenou lekci" />
          </Field>
        )}
      </div>
    </Modal>
  );
}

/**
 * Tlačítko a historie bonusů pro jednu klientku.
 * cil: kam půjde další bonus (nebo { nelze }), bonusy: historie z API.
 */
export function BonusoveVstupyBlok({ cil, bonusy = [], smiBonus = false, smiSmazat = false, jmeno, onZmena, className = "" }) {
  const [otevreno, setOtevreno] = useState(false);
  const [maze, setMaze] = useState(null);
  const lzePridat = smiBonus && cil && !cil.nelze;

  const smaz = async (b) => {
    const ok = await confirmDialog({
      title: "Smazat bonusový vstup?",
      description: `Klientce se odebere +${b.pocet} ${sklonujVstup(b.pocet)} (${b.duvod}). Použijte jen u bonusu zadaného omylem.`,
      confirmLabel: "Smazat bonus",
      variant: "danger",
    });
    if (!ok) return;
    setMaze(b.id);
    try {
      await posli({ akce: "bonus-smazat", id: b.id });
      toast("Bonus smazán.", "success");
      if (onZmena) await onZmena();
    } catch (e) {
      toast(e.message, "error");
    } finally {
      setMaze(null);
    }
  };

  if (!smiBonus && !bonusy.length) return null;

  return (
    <div className={className}>
      {smiBonus && (
        <div className="flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-3">
          <button type="button" className="btn-secondary btn-sm w-full sm:w-auto" onClick={() => setOtevreno(true)} disabled={!lzePridat}>
            <Gift className="h-4 w-4" /> Přidat bonusový vstup
          </button>
          {cil && cil.nelze && <span className="text-[12.5px] text-slate-500">{cil.nelze}</span>}
        </div>
      )}

      {bonusy.length > 0 && (
        <div className="mt-3">
          <div className="mb-1.5 text-[11px] font-bold uppercase tracking-wider text-slate-400">Historie bonusů, {bonusy.length}</div>
          <div className="space-y-1.5">
            {bonusy.map((b) => (
              <div key={b.id} className="flex items-center gap-2.5 rounded-xl border border-slate-200 bg-white px-3 py-2">
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                    <Stitek ton="zlata" velikost="mala" ikona={Gift}>+{b.pocet} {sklonujVstup(b.pocet)}</Stitek>
                    <span className="min-w-0 break-words text-sm font-semibold text-slate-800">{b.duvod}</span>
                    {b.kamaradka && <Stitek ton="znacka" velikost="mala" ikona={UserRound}><span className="select-none">{b.kamaradka}</span></Stitek>}
                  </div>
                  <div className="text-[11.5px] text-slate-500">
                    {[b.kdo || null, kdyText(b.kdy), b.tarif ? `k permanentce ${b.tarif}` : null].filter(Boolean).join(", ")}
                  </div>
                </div>
                {!b.lzeSmazat && <Stitek ton="neutralni" velikost="mala">využitý</Stitek>}
                {smiSmazat && b.lzeSmazat && (
                  <button type="button" className="btn-ikona" onClick={() => smaz(b)} disabled={maze === b.id}
                    aria-label="Smazat bonus" title="Smazat bonus zadaný omylem">
                    <Trash2 className="h-4 w-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <PridatBonusDialog open={otevreno} onClose={() => setOtevreno(false)} cil={cil} jmeno={jmeno} onHotovo={onZmena} />
    </div>
  );
}
